import { render, staticRenderFns } from "./GerarDocModalForm.vue?vue&type=template&id=0383d4f5"
import script from "./GerarDocModalForm.vue?vue&type=script&lang=js"
export * from "./GerarDocModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports